import request from '@/utils/request'

export function orderAmountChart(query) {
  return request({
    url: '/statistics/order/order/amount',
    method: 'get',
    params: query
  })
}
export function orderCancelChart(query) {
  return request({
    url: '/statistics/order/order/cancel',
    method: 'get',
    params: query
  })
}

export function orderRefundChart(query) {
  return request({
    url: '/statistics/order/order/refund',
    method: 'get',
    params: query
  })
}

export function orderTimeChart(query) {
  return request({
    url: '/statistics/order/order/time',
    method: 'get',
    params: query
  })
}
export function orderNationChart(query) {
  return request({
    url: '/statistics/order/order/nation',
    method: 'get',
    params: query
  })
}

export function orderUserCount(query) {
  return request({
    url: '/statistics/order/order/user/count',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

export function distributorAmountChart(query) {
  return request({
    url: '/statistics/order/distributor/amount',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

export function distributorGoodsAmountChart(query) {
  return request({
    url: '/statistics/order/distributor/goods/amount',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

export function distributorStatistics(query) {
  return request({
    url: '/statistics/order/distributor/statistics',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

/** RFM 客户分群统计 */
export function getRfmGroupStatistics(query) {
  return request({
    url: '/statistics/order/rfm/statistics',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

/** RFM 用户明细分页 */
export function getRfmUserPage(query) {
  return request({
    url: '/statistics/order/rfm/user/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}
